import { Suspense } from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/toaster';
import { authRoutes } from '@/routes/config/authRoutes';
import { dashboardRoutes } from '@/routes/config/dashboardRoutes';
import RLoadingScreen from '@/components/RComponents/RLoaderScreen/RLoadingScreen';
import { NotificationProvider } from '@/views/notifications/contexts/NotificationContext';
// import { useSelector } from 'react-redux';
// import { RootState } from '@/store/store';
// import { sidebarContent } from '@/components/RComponents/SidebarComponents/data/sidebarContent';
// import { getFirstRoute } from '@/utils/helperFunctions';
// import { setFirstRoute } from '@/store/slices/authSlice';
// import { useDispatch } from 'react-redux';

const App = () => {
  // const dispatch = useDispatch();
  const router = createBrowserRouter([
    {
      path: '/',
      element: <Navigate to="/auth/login" replace />
    },
    authRoutes,
    dashboardRoutes,
    {
      path: '*',
      element: <Navigate to="/auth/login" replace />
    }
  ]);

  // const { permissions: userPermissions } = useSelector((state: RootState) => state.auth);
  // const hasSuperAdminPermission = userPermissions.includes("ROLE_SUPER_ADMIN");

  // setTimeout(() => {  
  
  // }, 1000);

  return (
    <NotificationProvider>
      <main className="flex flex-col">
        <Suspense fallback={<RLoadingScreen />}>
          <RouterProvider router={router} />
        </Suspense>
      </main>
      <Toaster />
    </NotificationProvider>
  );
};

export default App;
